module.exports = __webpack_public_path__ + "static/media/kanatnaya.e3bc8f66.jpg";